import React from 'react';

function Header({ id, children, img, classe }) {

    return (
        <header 
            className={`${classe} mt-10 md:mt-20 h-72 w-full max-w-7xl mx-auto`}
            id={ id }
        >
            <div 
                className="relative z-10 px-3 bg-cover bg-center   w-full h-full flex justify-center items-center"
                style={{ backgroundImage: `url(${ img })` }}
            >
                <div className="absolute z-20 left-0 top-0 w-full h-full bg-primary opacity-20"></div>
                { children }
            </div>
        </header>
    );
}

export default Header;